import anime from 'animejs/lib/anime.es.js';

window.addEventListener('load', function (event) {
    const guidePage = document.getElementById('guide-page');

    if (guidePage) {
        //initIntersectionObserver();

        const guideMenuWrapper = document.getElementById('guides-menu');
        const guideMenuToggle = document.getElementById('guides-menu-toggle');

        const menu = guideMenuWrapper.querySelector('.guides-menu__inner');
        const overlay = guideMenuWrapper.querySelector('.guides-menu__overlay'); 

        const openMenu = () => {
            guideMenuWrapper.classList.add('guides-menu--active');
            guideMenuWrapper.parentNode.classList.add('guides-menu__wrapper--active')
            guideMenuToggle.setAttribute('aria-expanded', true);
       
            const sections = document.querySelectorAll('.js-section');

            if (guideMenuWrapper.classList.contains("guides-menu--initialised") == false) {
                sections.forEach(section => {
                    const title = section.querySelector('.js-title').innerHTML;
                    const subtitle = section.querySelector('.js-subtitle').innerHTML;

                    const items = section.querySelectorAll('.js-item-title');
                    let itemValues = [];

                    items.forEach(item => {
                        itemValues.push({ label: item.innerHTML, id: item.id });
                    })

                    menu.appendChild(createSection(title, subtitle, itemValues));
                });

                guideMenuWrapper.classList.add("guides-menu--initialised");
            }

            const links = menu.querySelectorAll('.scroll-link');
            links.forEach(link => {
                link.addEventListener('click', (e) => {
                    e.preventDefault();

                    closeMenu(e.target.getAttribute('data-scrollId'));
                })
            })

            menu.style.height = window['scrolInstance'].scroll.windowHeight + 'px';
            //menu.style.top = window['scrolInstance'].scroll.instance.scroll.y + 'px';

            window['scrolInstance'].stop();

            overlay.style.visibility = 'visible';

            let menuAnimationTimeline = anime.timeline({
                easing: 'linear',
            })

            menuAnimationTimeline
                .add({
                    targets: overlay,
                    duration: 350,
                    opacity: 1,            
                })
                .add({
                    delay: 100,
                    targets: menu,
                    duration: 350,
                    left: 0,
                })
            // animation
            

            const menuItems = document.querySelectorAll('[data-scrollid]');
            const guideSections = document.querySelectorAll('.js-item-title')
            let currentSectionInViewPort = null
            guideSections.forEach((section, index) => {
                isInViewPort(section) ? currentSectionInViewPort = index : '';
            })
            if(currentSectionInViewPort != null){
                for (let i = menuItems.length - 1; i >=0 ; i--) {
                    if (currentSectionInViewPort >= i) {
                        menuItems[i].style.opacity = "1";
                        menuItems[i].style.borderBottom = "1px solid #BABABA";
                    }
                }
            }
        }

        const isInViewPort = (element) => {
            const rect = element.getBoundingClientRect();
             return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
             );
        }

        const closeMenu = (scrollId = null) => {

            guideMenuToggle.setAttribute('aria-expanded', false);
        

            let menuAnimationTimeline = anime.timeline({
                easing: 'linear',
            })

            menuAnimationTimeline
                .add({
                    targets: overlay,
                    duration: 350,
                    opacity: 0,
                })
                .add({
                    delay: 100,
                    targets: menu,
                    duration: 350,
                    left: -620,
                })

            menuAnimationTimeline.finished.then(() => {
                guideMenuWrapper.classList.remove('guides-menu--active');

                overlay.style.visibility = 'hidden';
                guideMenuWrapper.parentNode.classList.remove('guides-menu__wrapper--active')
                window['scrolInstance'].start();

               
                if (typeof scrollId == "string" && scrollId) {
                    const scrollItem = document.querySelector("#" + scrollId);
                    if (scrollItem) {
                        window['scrolInstance'].scrollTo(scrollItem, {
                            duration: 500,
                            offset: - 100,
                        })
                    }
                }
            })
        }

        const handleScroll = args => {

            let heroPosition = document.querySelector('.guides-detail__view-hero').getBoundingClientRect();

            if ((args.scroll.y) >= heroPosition.bottom + 400) {
                guideMenuToggle.style.top = (args.scroll.y + window.scrolInstance.scroll.windowMiddle.y) + 'px';
        
                if (!guideMenuToggle.classList.contains('visible')) {
                    guideMenuToggle.classList.add('visible')
                }
            } else {
                if (guideMenuToggle.classList.contains('visible')) {
                    guideMenuToggle.classList.remove('visible')
                }
            }
        }

        const createSection = (title, subtitle, items) => {

            const sectionWrapper = document.createElement('div');
            sectionWrapper.classList.add('guides-menu__section');

            if (title) {
                const sectionHeading = document.createElement('h5');
                sectionHeading.classList.add('guides-menu__section-heading');
                sectionHeading.innerHTML = title;
                sectionWrapper.appendChild(sectionHeading);
            }

            if (subtitle) {
                const sectionSubheading = document.createElement('p');
                sectionSubheading.classList.add('guides-menu__section-location');
                sectionSubheading.innerHTML = subtitle;
                sectionWrapper.appendChild(sectionSubheading);
            }

            if (items.length > 0) {
                const itemList = document.createElement('ul');
                itemList.classList.add('guides-menu__section-list');

                for (let index = 0; index < items.length; index++) {
                    itemList.insertAdjacentHTML('beforeend', '<li class="guides-menu__section-list-item"><a class="scroll-link" data-scrollId="'+ items[index].id+'" href="#">' + items[index].label +'</a></li>')
                }

                sectionWrapper.appendChild(itemList);
            }

            return sectionWrapper;
        }

    
        if (guideMenuWrapper &&
            guideMenuToggle &&
            window.innerWidth > 768) {
            guideMenuToggle.addEventListener('click', openMenu)
            overlay.addEventListener('click', closeMenu);

            if (window.scrolInstance.scroll.windowWidth > 992) {
                window['scrolInstance'].on('scroll', (args) => { handleScroll(args) } );
            }
        }


    }
})
